module.exports = __webpack_public_path__ + "static/media/defaultPic1.acdaa2fb.svg";